(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const setupAvailabilitySorting = (scope = document) => {
    if (!(scope instanceof Document || scope instanceof Element)) return;
    scope.querySelectorAll('results-list').forEach((resultsList) => {
      if (resultsList.dataset.availabilitySortingReady === 'true') return;
      resultsList.dataset.availabilitySortingReady = 'true';

      const sortProductGrids = () => {
        resultsList.querySelectorAll('ul.product-grid').forEach((grid) => {
          const items = [...grid.querySelectorAll(':scope > .product-grid__item[data-product-available]')];
          const sortedItems = [...items].sort((first, second) => {
            return Number(second.dataset.productAvailable === 'true') - Number(first.dataset.productAvailable === 'true');
          });
          const orderChanged = sortedItems.some((item, index) => item !== items[index]);
          if (orderChanged) grid.append(...sortedItems);
        });
      };

      let sortScheduled = false;
      const observer = new MutationObserver(() => {
        if (sortScheduled) return;
        sortScheduled = true;
        requestAnimationFrame(() => {
          sortProductGrids();
          sortScheduled = false;
        });
      });

      observer.observe(resultsList, { childList: true, subtree: true });
      sortProductGrids();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAvailabilitySorting(), { once: true });
  } else {
    setupAvailabilitySorting();
  }

  document.addEventListener('shopify:section:load', (event) => setupAvailabilitySorting(event.target));


  } catch(e) { console.error(e); }
})();
})();
